export default "__VITE_ASSET__CO2nGIVj__"